// extracted by mini-css-extract-plugin
export default {"upvoteIcon":"wHucpslj","burstIcon":"iJ+P2sKW"};